import { render, staticRenderFns } from "./ComplianceTraderDetails.vue?vue&type=template&id=f9b43760&scoped=true&"
import script from "./ComplianceTraderDetails.vue?vue&type=script&lang=js&"
export * from "./ComplianceTraderDetails.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceTraderDetails.vue?vue&type=style&index=0&id=f9b43760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b43760",
  null
  
)

export default component.exports